import React from "react";
import cloud from "../../assets/svg/cloud.svg";
import dotnet from "../../assets/svg/dotnet.svg";
import mobile from "../../assets/svg/mobile.svg";
import ai from "../../assets/svg/ai.svg";
import devsecops from "../../assets/svg/devsecops.svg";
import integration from "../../assets/svg/integration.svg";

const SERVICES = [
  {
    img: cloud,
    title: "Cloud Architecture & Migration",
    text: "On-prem to cloud migration and modernization on Azure & AWS — cost optimization, serverless adoption, containerization and Kubernetes for secure, high-availability platforms."
  },
  {
    img: dotnet,
    title: "Enterprise .NET & Full-Stack Engineering",
    text: "Architecting high-availability apps with .NET Core, ASP.NET Web API / MVC, WPF, Node.js, and modern front-ends in React, Angular and Next.js — built on SOLID principles."
  },
  {
    img: mobile,
    title: "Mobile Solutions & Automation",
    text: "Reusable cross-platform React Native frameworks for iOS & Android, custom UI components, and fully automated QA-to-store app distribution pipelines."
  },
  {
    img: ai,
    title: "AI, GenAI & Data Engineering",
    text: "AI-powered solutions with Generative AI, OCR/LLM pipelines and intelligent validation — plus data modernization and analytics on cloud-native, event-driven architectures."
  },
  {
    img: devsecops,
    title: "DevSecOps & Automation",
    text: "CI/CD pipelines, infrastructure automation and reusable build/release templates, with monitoring, auto-scaling and OWASP-aligned security baked into delivery."
  },
  {
    img: integration,
    title: "Integration, APIs & Security",
    text: "Secure integration frameworks and RESTful APIs — API management, identity-provider integration (OAuth/OIDC) and encrypted, standards-based data exchange between systems."
  }
];

function Services() {
  return (
    <section id="services" className="block">
      <div className="container">
        <div className="section-head">
          <span className="eyebrow"><span className="dot"></span>What I Do</span>
          <h2>Services &amp; Expertise</h2>
          <p>End-to-end architecture and delivery across cloud, backend, mobile, AI, DevSecOps and secure integration.</p>
        </div>
        <div className="cards">
          {SERVICES.map((s) => (
            <article className="gcard" key={s.title}>
              <span className="svg-thumb">
                <img src={s.img} alt="" aria-hidden="true" />
              </span>
              <h3>{s.title}</h3>
              <p>{s.text}</p>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}

export default Services;
